import clsx, { type ClassValue } from "clsx";
import { type ForwardedRef, forwardRef, type PropsWithChildren } from "react";

const AnimatedSpanEl = forwardRef(
  (
    {
      className,
      children,
    }: PropsWithChildren & {
      className?: ClassValue | ClassValue[];
    },
    ref: ForwardedRef<HTMLDivElement>,
  ) => {
    return (
      <div className="inline-flex relative w-fit overflow-hidden h-fit">
        <span className={clsx("relative z-1 opacity-60", className)}>
          {children}
        </span>
        <div
          ref={ref}
          className="absolute z-2 min-h-fit flex flex-col inset-x-0 top-0"
        >
          <span className="opacity-0">{children}</span>
          <span className="opacity-100">{children}</span>
        </div>
      </div>
    );
  },
);
AnimatedSpanEl.displayName = "AnimatedSpanEl";
export default AnimatedSpanEl;
